import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Package } from "lucide-react";
import SEO from "@/components/SEO";
import { STORE_NAME } from "@/lib/seo";

export default function OrderSuccess() {
    const [params] = useSearchParams();
    const order = params.get("n");
    const phone = params.get("p");
    return (
        <div className="container mx-auto px-4 py-16 max-w-xl text-center" data-testid="order-success-page">
            <SEO title={`Order Placed | ${STORE_NAME}`} description="Your order has been placed successfully." noindex />
            <CheckCircle2 size={56} className="mx-auto text-[#34C759]" />
            <h1 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight mt-4">
                Order placed!
            </h1>
            <p className="text-white/65 mt-2">
                Thanks for shopping at Opensea. We'll confirm your order shortly via phone.
            </p>
            {order && (
                <div className="mt-6 inline-block border border-[#27272A] bg-[#121214] rounded-sm px-5 py-4">
                    <div className="text-[11px] uppercase tracking-widest text-white/55 font-display">Order #</div>
                    <div className="font-display font-black text-2xl mt-1" data-testid="success-order-number">{order}</div>
                </div>
            )}
            <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center">
                <Link
                    to={`/track-order${order && phone ? `?n=${order}&p=${encodeURIComponent(phone)}` : ""}`}
                    className="bg-[#00BCE5] text-black font-display font-bold uppercase tracking-widest px-6 py-3 rounded-sm hover:bg-[#33C9EA] btn-primary-glow inline-flex items-center justify-center gap-2"
                    data-testid="success-track-cta"
                >
                    <Package size={16} /> Track order
                </Link>
                <Link
                    to="/shop"
                    className="border border-white/30 text-white font-display font-bold uppercase tracking-widest px-6 py-3 rounded-sm hover:border-[#00BCE5] hover:text-[#00BCE5]"
                >
                    Keep shopping
                </Link>
            </div>
        </div>
    );
}
